<template>
  <div id="intro">
    <div id="introContainer">
      <!--
      <transition name="slide">
        <div id="introImage" v-if="showIntroImage && !hasMobileMentor"></div>
      </transition>

      <transition name="slide">
        <div id="mmIntroImage" v-if="showIntroImage && hasMobileMentor"></div>
      </transition>
      -->

      <transition name="fade">
        <div id="mmIntroText" v-if="showIntroText && hasMobileMentor">
          <div id="welcome">                       
              <p id="welcomeBig">Are you ready for your launch?</p>
              <p>Launching a drug is a complex process, but our Launch Grader is here to help. This tool simplifies the daunting task of evaluating your training readiness, offering a clear picture of your current plans' effectiveness.</p>
              <p>Our comprehensive assessment identifies strengths, uncovers potential gaps, and highlights new opportunities for improvement — ensuring your team is fully prepared for a successful launch. </p>
              <p>Let’s make your next launch seamless and impactful.</p>
          </div>
          <v-row class="justify-center">
            <v-col cols="12" sm="6">
              <v-btn color="success" block large @click="leaveIntro">
                 START
              </v-btn>
            </v-col>
          </v-row>

          <div id="introFooter">
            <p>Need urgent help with a launch?<br/>Email us at <a href="mailto:info@cldinc.com" target="_blank">info@cldinc.com</a> </p>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Intro',
  props: {
    
  },
  computed: {
    ...mapGetters([
      'showIntro',
      'hasMobileMentor',
      'completedPretest',
      'pretestQuestions',
      'disclaimer',
    ])
  },
  methods: {
    ...mapActions([
      'hideIntro'
    ]),
    leaveIntro(){
      let theIntro = this;
      theIntro.showIntroImage = false;
      theIntro.showIntroText = false;    
      window.setTimeout(()=>{
        theIntro.hideIntro();
      }, 250)  
    }
  },
  mounted(){
    this.showIntroImage = true;
    this.showIntroText = true;
  },
  data(){
    return {
      showIntroImage: false,
      showIntroText: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#introContainer{
  top: 50px;
  position: absolute;
  left: 0;
  right: 0;
  height: calc(100% - 50px);
}

#introImage, #mmIntroImage{
  float: left;
  height: 100%;
  width: 30%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
}

#introImage{
  /*background-image: url("../assets/img/introImage.jpg");*/
}
#mmIntroImage{
  /*background-image: url("../assets/img/mentor_intro.jpg");*/
}

#introText, #mmIntroText{
/*  float: left;
  height: 100%;
  width: 70%;
  overflow-y: auto;*/
  height: calc(100vh - 50px);
  height: calc(100svh - 50px);
  color: white;
/*  background-size: cover;
  background-repeat: no-repeat;*/
  /*border-left: 15px solid rgba(0,0,0,0.2);*/
  box-sizing: border-box;
}

#welcome{
  position: relative;
  width: 90%;
  margin: 0 auto;
  padding: 20px;
  font-size: 24px;
  margin-top: 0;
}

#welcomeBig{
  font-size: 45px;
  font-weight: bold;
}


#begin{
  margin-top: 50px;
  color: #055272;
  height: 60px;
}


/* Mobile Mentor Intro Styles */
.pretestNumberContainer{
  width: 100%;
}


.disclaimer-container{
  margin-top: 50px;
  text-align: center;
}

.intro-disclaimer{
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  width: 100%;
}



@media(max-width: 667px){
  #begin{
    margin-top: 0;
  }
  #pretestResults{
    width: 100%;
  }
  #welcome{
    padding: 0;
    font-size: 15px;
    margin-top: 0;
    width: 100%;
  }
/*  #introText #welcomeBig{
    font-size: 30px;
    background-image: url(../assets/img/introImage.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    height: 160px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-position-y: 2%;
  }*/
  #welcomeBig{
    line-height: 1.2em;
  }

  #welcomeBig > p{
    text-shadow: 3px 4px 8px #000000;
  }
  #welcomeSmall{
    padding: 10px;
  }

  .numberRowContainer{
/*    font-size: 15px;*/
  }
  #introImage{
    display: none;
  }
  #introText, #mmIntroText{
    padding: 15px;
    height: 100%;
    width: 100%;
    border-left: 0px;
  }

  #introContainer{
/*    overflow-y: auto;*/
/*    -webkit-overflow-scrolling: touch;*/
  }
  #mmIntroImage{
    height: 150px;
    width: 100%;
    /*background-image: url(../assets/img/mentor_results.jpg);*/
  }
  #mmIntroText{
/*    background-position: center;
    height: calc(100vh - 200px);
    height: 100%;
    width: 100%;
    overflow-y: hidden;*/
  }
}

#introFooter{
  font-weight: bold;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: 100px;
}
#introFooter a{
  color: #82bc5c;
}
</style>
